<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mKfLq8/images/9780825444296_cover.jpg?1684514754276" alt="This image is the cover for the book Control Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Control Girl
      </h1>
      <p class="bookDescription body article font2">
        <p>Little fights with your husband and kids. Unhappiness when things don't match your version of perfect. Tension, anger, fear--it all begins with a heart that craves control. When your vision of how life should be replaces God's vision, you doom your quest for security, peace, and joy before it even starts. Thankfully, there is a better way.</p><p>Join Shannon as she shares what she has discovered about her own control struggles and about God from studying Control Girls in the Bible. Learn how you too can lay down this burden and find rest in surrendering to the One who truly is in control.</p><p>"In this funny, tender, and truth-telling book, Shannon Popkin peels back the layers of our control problem."<br/>--Erin Davis, author, blogger, and recovering Control Girl</p><p>"In the style of Liz Curtis Higgs, <i>Control Girl</i> is an easy and entertaining read, yet Shannon Popkin packs a punch where we so need it if we are to be set free from the stressful habit that robs our joy and ruins our relationships!"<br/>--Dee Brestin, author of <i>Idol Lies</i></p><p>"With personal vulnerability, biblical depth, powerful personal illustrations, and pointed application questions, Shannon Popkin reveals how seven women of the Bible can teach us how to surrender our will to God's design for our future."<br/>--Carol Kent, speaker and author of <i>Becoming a Woman of Influence</i></p><p>"<i>Control Girl</i> is a penetrating look at how selfishness and self-protectiveness wreck lives--and why surrender and trust are God's life-giving pathways to true freedom and joy."<br/>--Nancy DeMoss Wolgemuth, author and Revive Our Hearts teacher and host</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shannon Popkin
      </h2>
      
      <p class="authorDescription body article">Shannon Popkin is a wife and mom, a speaker and teacher, and a leader of small group studies. She's been published by Family Fun, MOMsense, Focus on the Family Magazine, and other outlets. She is a contributing blogger for True Woman.com and has blogged for several years at shannonpopkin.com. This is her first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kregel Publications
     </h2>
        
        
     <a class="publisherURL body link" href="http://www.kregel.com/" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     <a class="publisherURL body link" href="http://www.kregel.com/christian-living-and-devotionals/control-girl/" target="_blank">
  
          More  About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?de10edca